import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spinner, Container } from 'react-bootstrap';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { currentUser, loading, trialStatus } = useAuth();

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (currentUser) {
    if (trialStatus?.isTrialExpired) {
      return <Navigate to="/select-plan" state={{ trialExpired: true }} replace />;
    }
    // Check for pending paid plan from registration flow (set in Register.tsx)
    const pendingPlan = localStorage.getItem('pendingPlan');
    if (pendingPlan) {
      localStorage.removeItem('pendingPlan');
      return <Navigate to={`/select-plan?plan=${pendingPlan}`} replace />;
    }
    return <Navigate to="/home" />;
  }

  return <>{children}</>;
};

export default PublicRoute;